import { fetchHashtags } from '@/entities/insight';
import { useQuery } from '@tanstack/react-query';

export function useHashtags(params: Parameters<typeof fetchHashtags>[0], enabled?: boolean) {
  return useQuery({
    queryKey: [
      'hashtags',
      params.queryId,
      params.startDate,
      params.endDate,
      JSON.stringify(params.publicFilter),
    ],
    queryFn: ({ signal }) => fetchHashtags(params, signal),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    enabled,
  });
}
